(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pickaleaf-world-gateway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gateways = document.querySelectorAll('[data-pickaleaf-gateway]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    gateways.forEach((gateway) => {
      const drawer = gateway.querySelector('[data-gateway-drawer]');
      const openButton = gateway.querySelector('[data-gateway-menu-open]');
      const closeButton = gateway.querySelector('[data-gateway-menu-close]');
      const enterButton = gateway.querySelector('[data-gateway-enter]');
      const discovery = gateway.querySelector('[data-gateway-discovery]');
      const discoveryHeading = gateway.querySelector('[data-discovery-heading]');
      const backButton = gateway.querySelector('[data-gateway-back]');
      const choices = gateway.querySelectorAll('[data-discovery-choice]');
      const catalog = gateway.querySelector('[data-pickaleaf-catalog]');
      const catalogBack = gateway.querySelector('[data-catalog-back]');
      const catalogViews = gateway.querySelectorAll('[data-catalog-view]');
      const catalogRails = gateway.querySelectorAll('[data-catalog-rail]');
      const catalogCounter = gateway.querySelector('[data-catalog-counter]');
      const catalogProgress = gateway.querySelector('[data-catalog-progress]');
      const deepTransition = gateway.querySelector('[data-deep-transition]');
      const deepTransitionImage = gateway.querySelector('[data-deep-transition-image]');
      const logoImages = gateway.querySelectorAll('.pickaleaf-gateway__logo, .pickaleaf-discovery__logo, .pickaleaf-catalog__logo');
      let frame = 0;
      let transitioning = false;
      let activeRail = null;
      let edgeSwipeStartX = 0;
      let edgeSwipeStartY = 0;
      let edgeSwipeStartedAt = 0;
      let edgeSwipeTracking = false;

      logoImages.forEach((logoImage) => {
        const lockup = logoImage.closest('[data-brand-lockup]');
        const showFallback = () => lockup?.classList.add('logo-failed');
        logoImage.addEventListener('error', showFallback);
        if (logoImage.complete && logoImage.naturalWidth === 0) showFallback();
      });

      openButton?.addEventListener('click', () => {
        if (drawer && !drawer.open) drawer.showModal();
      });

      closeButton?.addEventListener('click', () => drawer?.close());

      drawer?.addEventListener('click', (event) => {
        if (event.target === drawer) drawer.close();
      });

      if (!reducedMotion) {
        gateway.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const bounds = gateway.getBoundingClientRect();
            const x = ((event.clientX - bounds.left) / bounds.width - 0.5) * 18;
            const y = ((event.clientY - bounds.top) / bounds.height - 0.5) * 12;
            gateway.style.setProperty('--gateway-x', x.toFixed(2));
            gateway.style.setProperty('--gateway-y', y.toFixed(2));
          });
        });

        gateway.addEventListener('pointerleave', () => {
          gateway.style.setProperty('--gateway-x', '0');
          gateway.style.setProperty('--gateway-y', '0');
        });
      }

      const formatCounter = (value) => String(value).padStart(2, '0');
      const catalogHashes = {
        world: '#discover-worlds',
        silhouette: '#discover-forms'
      };

      const persistCatalogHistory = (choiceName) => {
        const hash = catalogHashes[choiceName];
        if (!hash || !window.history.replaceState) return;
        const currentState = window.history.state && typeof window.history.state === 'object'
          ? window.history.state
          : {};
        const state = { ...currentState, pickaleafCatalog: choiceName };
        window.history.replaceState(state, '', window.location.href);
      };

      const clearCatalogHistory = () => {
        if (!window.history.replaceState) return;
        const currentState = window.history.state && typeof window.history.state === 'object'
          ? { ...window.history.state }
          : {};
        const hasSavedChoice = Object.prototype.hasOwnProperty.call(currentState, 'pickaleafCatalog');
        if (!hasSavedChoice && !Object.values(catalogHashes).includes(window.location.hash)) return;
        currentState.pickaleafCatalog = null;
        window.history.replaceState(currentState, '', window.location.href);
      };

      const catalogChoice = () => {
        const s = window.history.state;
        if (s && typeof s === 'object' && Object.prototype.hasOwnProperty.call(s, 'pickaleafCatalog')) {
          return s.pickaleafCatalog === 'world' || s.pickaleafCatalog === 'silhouette' ? s.pickaleafCatalog : null;
        }
        const h = window.location.hash;
        return h === '#discover-worlds' ? 'world' : h === '#discover-forms' ? 'silhouette' : null;
      };

      const restoreCatalogHistory = () => {
        const choiceName = catalogChoice();
        if (!choiceName) return;

        const activeView = gateway.querySelector(`[data-catalog-view="${choiceName}"]`);
        const rail = activeView?.querySelector('[data-catalog-rail]');
        if (!activeView || !rail) return;

        gateway.classList.add('is-restoring-catalog', 'is-discovering', 'is-catalog');
        discovery?.setAttribute('inert', '');
        discovery?.setAttribute('aria-hidden', 'true');
        catalog?.removeAttribute('inert');
        catalog?.setAttribute('aria-hidden', 'false');
        catalogViews.forEach((view) => {
          const isActive = view === activeView;
          view.classList.toggle('is-active', isActive);
          view.setAttribute('aria-hidden', String(!isActive));
        });
        activeRail = rail;
        activeView.querySelectorAll('[data-catalog-card]').forEach((card) => card.classList.add('is-visible'));
        updateRailProgress(activeRail);
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => gateway.classList.remove('is-restoring-catalog'));
        });
      };

      const updateRailProgress = (rail) => {
        if (!rail) return;
        const cards = Array.from(rail.querySelectorAll('[data-catalog-card]'));
        const maxScroll = Math.max(1, rail.scrollWidth - rail.clientWidth);
        const progress = Math.max(.035, Math.min(1, rail.scrollLeft / maxScroll));
        const railCenter = rail.getBoundingClientRect().left + (rail.clientWidth / 2);
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs((rect.left + rect.width / 2) - railCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        gateway.style.setProperty('--catalog-progress', progress.toFixed(4));
        if (catalogCounter) {
          catalogCounter.textContent = `${formatCounter(nearestIndex + 1)} / ${formatCounter(cards.length)}`;
        }
      };

      const revealCatalogCards = (view) => {
        const cards = view ? view.querySelectorAll('[data-catalog-card]') : [];
        cards.forEach((card, index) => {
          card.classList.remove('is-visible');
          window.setTimeout(
            () => card.classList.add('is-visible'),
            reducedMotion ? 0 : 140 + Math.min(index, 5) * 105
          );
        });
      };

      const flyThrough = (source, onMidpoint, onComplete, midpointDelay = 880) => {
        const sourceImage = source?.querySelector('img');
        if (!source || !sourceImage || !deepTransition || !deepTransitionImage || reducedMotion) {
          onMidpoint?.();
          onComplete?.();
          return;
        }

        const sourceRect = source.getBoundingClientRect();
        const gatewayRect = gateway.getBoundingClientRect();
        const sourceCenterX = sourceRect.left - gatewayRect.left + sourceRect.width / 2;
        const sourceCenterY = sourceRect.top - gatewayRect.top + sourceRect.height / 2;
        const deepX = gatewayRect.width / 2 - sourceCenterX;
        const deepY = gatewayRect.height / 2 - sourceCenterY;
        const deepScale = Math.max(
          gatewayRect.width / sourceRect.width,
          gatewayRect.height / sourceRect.height
        ) * 1.04;
        const isWorldFlight = source.getAttribute('data-discovery-choice') === 'world';
        const flightDuration = isWorldFlight ? 1210 : 2350;
        deepTransitionImage.src = sourceImage.currentSrc || sourceImage.src;
        deepTransition.style.top = `${sourceRect.top - gatewayRect.top}px`;
        deepTransition.style.left = `${sourceRect.left - gatewayRect.left}px`;
        deepTransition.style.width = `${sourceRect.width}px`;
        deepTransition.style.height = `${sourceRect.height}px`;
        deepTransition.style.setProperty('--deep-x', `${deepX}px`);
        deepTransition.style.setProperty('--deep-y', `${deepY}px`);
        deepTransition.style.setProperty('--deep-scale', deepScale.toFixed(4));
        deepTransition.style.setProperty('--deep-scale-end', (deepScale * 1.16).toFixed(4));
        deepTransition.classList.toggle('is-world-flight', isWorldFlight);
        deepTransition.classList.remove('is-flying');
        void deepTransition.offsetWidth;
        deepTransition.classList.add('is-flying');

        if (isWorldFlight) {
          window.setTimeout(() => onMidpoint?.(), 425);
          window.setTimeout(() => gateway.classList.add('is-world-crossfading'), 675);
        } else if (midpointDelay === 0) {
          onMidpoint?.();
        } else {
          window.setTimeout(() => onMidpoint?.(), midpointDelay);
        }
        window.setTimeout(() => {
          deepTransition.classList.remove('is-flying');
          deepTransition.classList.remove('is-world-flight');
          gateway.classList.remove('is-world-crossfading');
          deepTransition.removeAttribute('style');
          onComplete?.();
        }, flightDuration + 10);
      };

      enterButton?.addEventListener('click', (event) => {
        event.preventDefault();
        if (transitioning || gateway.classList.contains('is-entering') || gateway.classList.contains('is-discovering')) return;
        transitioning = true;
        enterButton.setAttribute('aria-busy', 'true');
        gateway.classList.add('is-entering');
        gateway.dispatchEvent(new CustomEvent('pickaleaf:enter', { bubbles: true }));

        window.setTimeout(() => {
          gateway.classList.add('is-discovering');
          discovery?.removeAttribute('inert');
          discovery?.setAttribute('aria-hidden', 'false');
          if (discovery) discovery.scrollTop = 0;
        }, reducedMotion ? 20 : 240);

        window.setTimeout(() => {
          gateway.classList.add('is-crossfading');
        }, reducedMotion ? 25 : 1350);

        window.setTimeout(() => {
          gateway.classList.remove('is-entering');
          gateway.classList.remove('is-crossfading');
          enterButton.removeAttribute('aria-busy');
          transitioning = false;
          discoveryHeading?.focus({ preventScroll: true });
        }, reducedMotion ? 30 : 2420);
      });

      backButton?.addEventListener('click', () => {
        if (transitioning || gateway.classList.contains('is-catalog')) return;
        discovery?.setAttribute('inert', '');
        discovery?.setAttribute('aria-hidden', 'true');
        gateway.classList.remove('is-discovering');
        window.setTimeout(() => enterButton?.focus({ preventScroll: true }), reducedMotion ? 20 : 650);
      });

      choices.forEach((choice) => {
        choice.addEventListener('click', (event) => {
          event.preventDefault();
          if (transitioning) return;
          transitioning = true;
          const choiceName = choice.getAttribute('data-discovery-choice');
          const activeView = gateway.querySelector(`[data-catalog-view="${choiceName}"]`);
          const rail = activeView?.querySelector('[data-catalog-rail]');
          choice.classList.add('is-selected');
          gateway.dispatchEvent(new CustomEvent('pickaleaf:choice', {
            bubbles: true,
            detail: { choice: choiceName }
          }));

          catalogViews.forEach((view) => {
            const isActive = view === activeView;
            view.classList.toggle('is-active', isActive);
            view.setAttribute('aria-hidden', String(!isActive));
          });

          if (rail) rail.scrollLeft = 0;
          activeRail = rail;
          updateRailProgress(activeRail);

          const activateCatalog = () => {
            discovery?.setAttribute('inert', '');
            discovery?.setAttribute('aria-hidden', 'true');
            catalog?.removeAttribute('inert');
            catalog?.setAttribute('aria-hidden', 'false');
            gateway.classList.add('is-catalog');
            revealCatalogCards(activeView);
          };

          const completeChoice = () => {
            choice.classList.remove('is-selected');
            gateway.classList.remove(
              'is-diving-choice',
              'is-entering-world',
              'is-world-crossfading',
              'is-entering-choice',
              'is-choice-crossfading',
              'is-dissolving-choice'
            );
            deepTransition?.classList.remove('is-flying', 'is-choice-scene');
            deepTransition?.removeAttribute('style');
            gateway.style.removeProperty('--world-origin-x');
            gateway.style.removeProperty('--world-origin-y');
            gateway.querySelector(`[data-catalog-heading="${choiceName}"]`)?.focus({ preventScroll: true });
            transitioning = false;
          };

          if (!reducedMotion) {
            gateway.classList.add('is-dissolving-choice');
            activateCatalog();
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => gateway.classList.add('is-choice-crossfading'));
            });
            window.setTimeout(completeChoice, 1150);
          } else {
            activateCatalog();
            completeChoice();
          }
        });
      });

      const closeCatalog = () => {
        if (transitioning) return;
        clearCatalogHistory();
        catalog?.setAttribute('inert', '');
        catalog?.setAttribute('aria-hidden', 'true');
        discovery?.removeAttribute('inert');
        discovery?.setAttribute('aria-hidden', 'false');
        gateway.classList.remove('is-catalog');
        catalogViews.forEach((view) => {
          view.classList.remove('is-active');
          view.setAttribute('aria-hidden', 'true');
        });
        activeRail = null;
        window.setTimeout(() => discoveryHeading?.focus({ preventScroll: true }), reducedMotion ? 20 : 520);
      };

      catalogBack?.addEventListener('click', closeCatalog);

      catalog?.addEventListener('touchstart', (event) => {
        if (!gateway.classList.contains('is-catalog') || transitioning || event.touches.length !== 1) return;
        const touch = event.touches[0];
        edgeSwipeTracking = touch.clientX <= 48;
        edgeSwipeStartX = touch.clientX;
        edgeSwipeStartY = touch.clientY;
        edgeSwipeStartedAt = performance.now();
      }, { passive: true });

      catalog?.addEventListener('touchend', (event) => {
        if (!edgeSwipeTracking || event.changedTouches.length !== 1) return;
        edgeSwipeTracking = false;
        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - edgeSwipeStartX;
        const distanceY = touch.clientY - edgeSwipeStartY;
        const elapsed = performance.now() - edgeSwipeStartedAt;
        if (distanceX >= 74 && Math.abs(distanceX) > Math.abs(distanceY) * 1.35 && elapsed <= 900) {
          closeCatalog();
        }
      }, { passive: true });

      catalog?.addEventListener('touchcancel', () => {
        edgeSwipeTracking = false;
      }, { passive: true });

      catalogRails.forEach((rail) => {
        let railFrame = 0;
        rail.addEventListener('scroll', () => {
          cancelAnimationFrame(railFrame);
          railFrame = requestAnimationFrame(() => updateRailProgress(rail));
        }, { passive: true });
      });

      gateway.querySelectorAll('[data-catalog-card]').forEach((card) => {
        card.addEventListener('click', (event) => {
          if (card.closest('[data-catalog-view="silhouette"]')) return;
          if (card.hasAttribute('data-instant-world')) {
            event.preventDefault();
            event.stopPropagation();
            persistCatalogHistory('world');
            window.location.assign(card.href);
            return;
          }
          if (reducedMotion || transitioning) return;
          event.preventDefault();
          transitioning = true;
          const destination = card.href;
          flyThrough(
            card,
            null,
            () => window.location.assign(destination)
          );
        });
      });

      restoreCatalogHistory();

      window.addEventListener('pageshow', () => {
        if (catalogChoice()) {
          restoreCatalogHistory();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
